import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[scipPasswordToggle]'
})
export class PasswordToggleDirective implements OnInit, OnChanges {
  @Input()
  disabled = false;

  private showPassword = false;

  private toggleContainerElement: HTMLElement;
  private toggleElement: HTMLElement;

  constructor(private elem: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Create container span for input and icon.
    const container: HTMLSpanElement = document.createElement('span');
    this.renderer.addClass(container, 'password-input-container');

    // Create an container for the password hide/unhide icon.
    this.toggleContainerElement = document.createElement('span');
    this.renderer.addClass(this.toggleContainerElement, 'toggle-container');

    // Create the hide/unhide icon
    this.toggleElement = document.createElement('span');
    this.renderer.addClass(this.toggleElement, 'icon-content-watch');
    // Add the hide/unhide icon to the container
    this.toggleContainerElement.appendChild(this.toggleElement);

    // Insert the container before and the anchor after the input element.
    this.elem.nativeElement.parentElement.insertBefore(container, this.elem.nativeElement);

    // Put the input element and anchor inside the container.
    container.appendChild(this.elem.nativeElement);
    container.appendChild(this.toggleContainerElement);

    // Lets calculate if the icon is clickable or not
    this.toggleIconClickable();

    // listen to click event on hide/unhide icon
    this.renderer.listen(this.toggleContainerElement, 'click', (event) => {
      this.showPassword = !this.showPassword;
      this.calculateVisibleState();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.toggleContainerElement) {
      this.toggleIconClickable();
      this.calculateVisibleState(true); // If there is a change we know we initially wants to hide it
    }
  }

  private calculateVisibleState(forceHide = false) {
    if (forceHide) {
      this.showPassword = false;
    }

    if (this.showPassword) {
      this.renderer.setAttribute(this.elem.nativeElement, 'type', 'text');
      this.renderer.addClass(this.toggleElement, 'icon-content-unwatch');
      this.renderer.removeClass(this.toggleElement, 'icon-content-watch');
    } else {
      this.renderer.setAttribute(this.elem.nativeElement, 'type', 'password');
      this.renderer.addClass(this.toggleElement, 'icon-content-watch');
      this.renderer.removeClass(this.toggleElement, 'icon-content-unwatch');
    }
  }

  private toggleIconClickable(): void {
    if (this.disabled) {
      this.renderer.addClass(this.toggleContainerElement, 'toggle-disabled');
    } else {
      this.renderer.removeClass(this.toggleContainerElement, 'toggle-disabled');
    }
  }
}
